<template>
  <div style="margin-top: -10px;">
    <el-tabs v-model="activeName" class="tabs">
      <el-tab-pane label="代申请" name="todo">
        <keep-alive>
        <HospitalChildTable
          v-if="activeName == 'todo'"
          :active="activeName"
        ></HospitalChildTable>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="被退回" name="rollback">
        <keep-alive>
        <HospitalChildTable
          v-if="activeName == 'rollback'"
          :active="activeName"
        ></HospitalChildTable>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="被拒绝" name="reject">
        <keep-alive>
        <HospitalChildTable
          v-if="activeName == 'reject'"
          :active="activeName"
        ></HospitalChildTable>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import HospitalChildTable from "./HospitalChildTable";
export default {
  props: {
    showTop: true,
  },
  data() {
    return {
      activeName: "todo",
    };
  },
  watch: {
    '$route.query.status': {
      handler () {
        if(this.$route.query.status == 4){
          this.activeName = 'rollback'
        }
      }
    }
  },
  created() {
    if(this.$route.query.status == 4){
      this.activeName = 'rollback'
    }
    if(this.$route.query.tap){
      this.activeName = this.$route.query.tap
      // if(this.activeName=='rollback'){
      //   this.isTimeout =1
      // }
    }
  },
  components: {
    HospitalChildTable,
  },
};
</script>

<style lang="scss" scoped>
@import "src/common/common";
</style>



// WEBPACK FOOTER //
// src/pages/child/hospital/HospitalChild.vue